import { useLang } from '../contexts/LanguageContext';
import { useScrollReveal, revealClass } from '../hooks/useScrollReveal';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Maria S.',
    locationPt: 'Lisboa',
    locationEs: 'Lisboa',
    textPt:
      'Excelente trabalho na montagem da minha cozinha IKEA. Pontual, organizado e muito profissional. Recomendo vivamente!',
    textEs:
      'Excelente trabajo en el montaje de mi cocina IKEA. Puntual, organizado y muy profesional. ¡Lo recomiendo encarecidamente!',
    rating: 5,
  },
  {
    name: 'João P.',
    locationPt: 'Setúbal',
    locationEs: 'Setúbal',
    textPt:
      'Colocaram piso flutuante em toda a minha casa. Trabalho impecável, sem manchas e dentro do prazo. Cinco estrelas!',
    textEs:
      'Instalaron suelo flotante en toda mi casa. Trabajo impecable, sin manchas y dentro del plazo. ¡Cinco estrellas!',
    rating: 5,
  },
  {
    name: 'Ana C.',
    locationPt: 'Almada',
    locationEs: 'Almada',
    textPt:
      'Remodelaram o meu escritório em tempo recorde. Limpeza, organização e qualidade em cada detalhe. Trabalho fantástico!',
    textEs:
      'Reformaron mi oficina en tiempo récord. Limpieza, organización y calidad en cada detalle. ¡Trabajo fantástico!',
    rating: 5,
  },
];

export default function Testimonials() {
  const { t, lang } = useLang();
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-24 sm:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`text-center mb-16 ${revealClass(isVisible)}`}>
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#C2410C] mb-4">
            <span className="w-6 h-px bg-[#C2410C]" />
            {t('testimonials_label')}
            <span className="w-6 h-px bg-[#C2410C]" />
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-zinc-900 tracking-tight"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="testimonials-title"
          >
            {t('testimonials_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((item, i) => (
            <TestimonialCard key={i} item={item} lang={lang} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ item, lang, index }) {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <div
      ref={ref}
      className={`bg-white border border-zinc-200 rounded-2xl p-7 hover:shadow-lg transition-all duration-300 ${revealClass(isVisible)}`}
      style={{ transitionDelay: `${index * 100}ms` }}
      data-testid={`testimonial-card-${index}`}
    >
      <div className="flex gap-1 mb-4">
        {Array.from({ length: item.rating }).map((_, i) => (
          <Star key={i} size={16} className="text-amber-400 fill-amber-400" />
        ))}
      </div>
      <p className="text-sm text-zinc-600 leading-relaxed mb-6 italic">
        "{lang === 'pt' ? item.textPt : item.textEs}"
      </p>
      <div className="flex items-center gap-3 border-t border-zinc-100 pt-4">
        <div className="w-9 h-9 rounded-full bg-[#C2410C]/10 flex items-center justify-center">
          <span className="text-sm font-bold text-[#C2410C]">{item.name[0]}</span>
        </div>
        <div>
          <div className="text-sm font-bold text-zinc-900">{item.name}</div>
          <div className="text-xs text-zinc-400">
            {lang === 'pt' ? item.locationPt : item.locationEs}
          </div>
        </div>
      </div>
    </div>
  );
}
